import React from 'react';

import {
  Actions as UIActions,
  Action,
  RefreshIcon,
  DeleteIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_SHARE,
  ACTION_DELETE,
} from 'scenes/CustomAudiences/LookalikeAudiences/constants';

const Actions = ({ limit, actions, withShare, onShare, onDelete }) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions limit={limit}>
          {withShare ? (
            <Action
              label={'Share'}
              icon={<RefreshIcon />}
              disabled={!isActionAllowed(ACTION_SHARE)}
              onClick={onShare}
            />
          ) : null}
          <Action
            label={'Delete'}
            icon={<DeleteIcon />}
            disabled={!isActionAllowed(ACTION_DELETE)}
            onClick={onDelete}
          />
        </UIActions>
      )}
    </Permissions>
  );
};

export default Actions;
